<template>
    <button class="btn btn-pill btn-primary py-2 px-5 font-weight-bold">
        <slot/>
    </button>
</template>

<script>
export default {}
</script>
